exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.khakhi {\n    background-color: #E6FFFF;\n}\n", ""]);

// exports
